import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { DEFAULT_MAX_LENGTH } from '../../../constants';
import FormStructureContext from '../../../context/FormStructureContext';
import messages from '../../../lang/en';
import faMessages from '../../../lang/fa';

const styles = createUseStyles({
    otherContainer: {
        marginTop: '8px'
    },
    input: {
        padding: '.375rem .75rem',
        borderColor: '#bbbbbb',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '4px',
        backgroundColor: 'white',
        color: '#363636',
        lineHeight: '1.5',
        height: 'calc(1.5em + .75rem + 2px)',
        minWidth: '125px',
        fontSize: '1em',
        fontFamily: 'inherit',
        marginTop: '5px',
        '&:focus': {
            outline: 'none',
            borderColor: '#1b90fa',
            boxShadow: '0 0 0 0.2rem rgb(0 123 255 / 25%)'
        },
        '&:disabled': {
            backgroundColor: 'rgba(204 204 204 / 30%) !important'
        }
    },
    label: {
        paddingInlineEnd: '4px'
    },
    disabledLabel: {
        color: '#ccc',
        paddingInlineEnd: '4px'
    },
    errorText: {
        fontSize: '13px',
        color: 'red',
        paddingTop: '4px',
        paddingInlineStart: '63px'
    }
});
interface OtherOptionInputProp {
    isEnabled?: boolean;
    name: string;
    value: string;
    handleInputChange: (e) => void;
    handleOnBlur?: (e) => void;
    errorOtherOption: boolean;
    required?: boolean;
    noAccess?: boolean;
}
const OtherOptionInput = ({
    isEnabled,
    name,
    value,
    handleInputChange,
    handleOnBlur,
    errorOtherOption,
    required,
    noAccess
}: OtherOptionInputProp) => {
    const classes = styles();
    const { fetchedFormStructure } = useContext(FormStructureContext);
    return (
        <>
            <div className={classes.otherContainer}>
                <label
                    className={!isEnabled ? classes.disabledLabel : classes.label}
                    htmlFor={name}
                >
                    {fetchedFormStructure?.presentation?.rtl
                        ? faMessages.select.otherOption
                        : messages.select.otherOption}
                    :
                </label>
                <input
                    type="text"
                    className={classes.input}
                    name={name}
                    disabled={!isEnabled || noAccess}
                    value={value}
                    required={required}
                    maxLength={DEFAULT_MAX_LENGTH}
                    autoComplete="off"
                    dir="auto"
                    onChange={handleInputChange}
                    onBlur={(e) => handleOnBlur?.(e)}
                />
            </div>
            {errorOtherOption && (
                <div className={classes.errorText}>the options include entered value</div>
            )}
        </>
    );
};
export default OtherOptionInput;
